import type { Lang } from './language.service';

const RU_PLURALS = new Intl.PluralRules('ru');

/**
 * Plural key for a count: `menu.positions` + 12 -> `menu.positions.few` (ru).
 * Uzbek has one form, so it always resolves to `.other`.
 */
export function countKey(base: string, n: number, lang: Lang): string {
  if (lang !== 'ru') return `${base}.other`;
  return `${base}.${RU_PLURALS.select(n)}`;
}

/** «от 1 155 сум», but «1 155 so'm dan»: the Uzbek word follows the price. */
export function fromFollowsPrice(lang: Lang): boolean {
  return lang === 'uz';
}
